/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["կգ․","կօ․","առվ","ցրկ","երկ","գշր"],["կեսգիշեր","կեսօր","առավոտյան","ցերեկը","երեկոյան","գիշերը"],["կեսգիշերին","կեսօրին","առավոտյան","ցերեկվա","երեկոյան","գիշերվա"]],[["կեսգիշեր","կեսօր","առավոտ","ցերեկ","երեկո","գիշեր"],u,u],["00:00","12:00",["06:00","12:00"],["12:00","18:00"],["18:00","24:00"],["00:00","06:00"]]];
